export default "__VITE_ASSET__iGnnp_U6__"